var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "task-settings" } },
    [
      _c(
        "a-tabs",
        {
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "a-tab-pane",
            { key: "workflow", attrs: { tab: _vm.$t("task.workflow") } },
            [_c("Workflow")],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "description",
              attrs: { tab: _vm.$t("message.description") },
            },
            [
              _c("div", { staticClass: "settings-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("task.settingsDesc1")) +
                    "\n                "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("task.settingsDesc2")) +
                    "\n                "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("task.settingsDesc3")) +
                    "\n                "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("task.settingsDesc4")) +
                    "\n            "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }